import { jsx as e, jsxs as r, Fragment as t } from "react/jsx-runtime";
import n from "./Jumbotron.js";
import { H as o } from "./chunks/index-UjijAVoZ.js";
import a from "./LinkWithButtonStyles.js";
import l from "./Why.js";
import i from "./How.js";
import s from "./CTA.js";
import m from "./Questions.js";
const p = () => /* @__PURE__ */ e("div", { className: "flex flex-col gap-7 items-center pb-4 tablet:gap-9 tablet:pb-6", children: /* @__PURE__ */ r(n, { className: "flex flex-col gap-5 px-5 py-8 w-full tablet:items-center tablet:text-center", children: [
  /* @__PURE__ */ e(o, { className: "leading-tight max-w-[25ch] text-blue-500", level: "1", children: "Partner with Frontend Mentor and earn a 30% commission" }),
  /* @__PURE__ */ e("p", { className: "max-w-prose text-lg text-neutral-500", children: "Become a Frontend Mentor partner and introduce our Learning, Teams, and Hiring platforms to your audience. Get 30% of every referral, even on renewals, and support developers in building hands-on skills." }),
  /* @__PURE__ */ e(a, { href: "https://partners.frontendmentor.io", children: "Apply now" })
] }) }), w = () => /* @__PURE__ */ r(t, { children: [
  /* @__PURE__ */ e(p, {}),
  /* @__PURE__ */ r("div", { className: "flex flex-col gap-9 px-5", children: [
    /* @__PURE__ */ e(l, {}),
    /* @__PURE__ */ e(i, {}),
    /* @__PURE__ */ e(s, {}),
    /* @__PURE__ */ e(m, {})
  ] })
] });
export {
  w as default
};
